"use client";

import { motion } from "framer-motion";

// Single paw print SVG
function PawPrint({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
      {/* Main pad */}
      <ellipse cx="12" cy="17" rx="5" ry="4" />
      {/* Top left toe */}
      <ellipse cx="6.5" cy="9" rx="2.5" ry="3" />
      {/* Top right toe */}
      <ellipse cx="17.5" cy="9" rx="2.5" ry="3" />
      {/* Middle left toe */}
      <ellipse cx="8.5" cy="5" rx="2" ry="2.5" />
      {/* Middle right toe */}
      <ellipse cx="15.5" cy="5" rx="2" ry="2.5" />
    </svg>
  );
}

export default function Loading() {
  // Create a trail of paws going diagonally - like an animal walking
  const pawTrail = Array.from({ length: 6 }, (_, i) => ({
    x: i * 40,
    y: i % 2 === 0 ? 0 : -20,
    rotation: i % 2 === 0 ? -30 : 30,
    delay: i * 0.25,
  }));

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-background">
      <div className="flex flex-col items-center">
        {/* Paw trail */}
        <div className="relative h-20 w-72 mb-8">
          {pawTrail.map((paw, index) => (
            <motion.div
              key={index}
              className="absolute text-primary"
              style={{
                left: paw.x,
                top: `calc(50% + ${paw.y}px)`,
                transform: `translateY(-50%) rotate(${paw.rotation}deg)`,
              }}
              initial={{ opacity: 0, scale: 0 }}
              animate={{
                opacity: [0, 0.8, 0.8, 0],
                scale: [0, 1, 1, 0.6],
              }}
              transition={{
                duration: 2,
                delay: paw.delay,
                repeat: Infinity,
                ease: "easeOut",
              }}
            >
              <PawPrint className="w-8 h-8" />
            </motion.div>
          ))}
        </div>

        {/* Loading text */}
        <motion.div
          className="flex items-center gap-1 text-muted-foreground"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
        >
          <span className="text-base font-medium">Ładowanie</span>
          <motion.span
            animate={{ opacity: [0, 1, 0] }}
            transition={{ duration: 1.2, repeat: Infinity }}
          >
            .
          </motion.span>
          <motion.span
            animate={{ opacity: [0, 1, 0] }}
            transition={{ duration: 1.2, repeat: Infinity, delay: 0.2 }}
          >
            .
          </motion.span>
          <motion.span
            animate={{ opacity: [0, 1, 0] }}
            transition={{ duration: 1.2, repeat: Infinity, delay: 0.4 }}
          >
            .
          </motion.span>
        </motion.div>
      </div>
    </div>
  );
}
